import React, { useState } from 'react';
import { connect } from 'react-redux';
import withStyles from 'react-jss';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';
import { sectionClassMapping } from '../ModalCompare.js';
import FuzzySearchBar from '../../../career-search/FuzzySearchBar';
import {
  getOnboardingState,
  getTenantState,
} from '../../../../store/selectors';
import CompareDegreesSection from './CompareDegreesSection';
import Loading from '../../Loading';

const careerTextStyles = {
  titleColor: () => ({
    color: 'grey',
  }),
  careerTextColor: (props) => ({
    color: props.tenant.primary,
  }),
};

function CompareDegrees(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [mainSections, setMainSections] = useState(true);
  const degreeList = props.degreeList;
  const dynamicCareersColor = props.classes.careerTextColor;
  const dynamicTitleTextColor = props.classes.titleColor;

  const sendFilteredListToParent = async (val) => {
    setFiltered(val);
  };

  const setDegreeListLoadingOnParent = (bool) => {
    setMainSections(bool);
    setLoading(bool);
  };

  const degreeListPerSection = () => {
    return {
      'All Degrees For Career': degreeList,
    };
  };

  const checkMainSectionsDisplay = async () => {
    await props.showCompareDegreesSearchBar();
  };

  // Create the 1 main section for all the Degrees For Career
  const getMainSections = () => {
    return map(degreeListPerSection(), (listOfDegrees, sectionName, lists) => {
      if (!listOfDegrees || listOfDegrees.length === 0) return null;

      return (
        <CompareDegreesSection
          dynamicTitleTextColor={dynamicTitleTextColor}
          dynamicCareersColor={dynamicCareersColor}
          dynamicSectionClass={sectionClassMapping[sectionName]}
          dynamicSectionTitle={sectionName}
          key={sectionName}
          checkMainSectionsDisplay={checkMainSectionsDisplay}
          section={sectionName}
          degreeList={listOfDegrees}
          addLine
        />
      );
    });
  };

  return (
    <div id="compare-page">
      <FuzzySearchBar
        inputText={t('Search Degrees')}
        tenant={props.tenant}
        listToSearch={degreeList}
        sendFilteredListToParent={sendFilteredListToParent}
        setSearchListLoadingOnParent={setDegreeListLoadingOnParent}
      />
      {/* Is the user actively searching or should we display just the 3 sections? */}
      {loading ? (
        <Loading height="100%" />
      ) : (
        <>
          {!mainSections ? (
            <CompareDegreesSection
              dynamicTitleTextColor={dynamicTitleTextColor}
              dynamicCareersColor={dynamicCareersColor}
              degreeList={filtered}
              dynamicSectionTitle={t('All Degrees For Career')}
              checkMainSectionsDisplay={checkMainSectionsDisplay}
              dynamicSectionClass={sectionClassMapping['Searching Careers...']}
              setMainSections={setMainSections}
            />
          ) : (
            getMainSections()
          )}
        </>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const tenant = getTenantState(state);

  return { onboarding, tenant };
}

export default connect(
  mapStateToProps,
  {}
)(withStyles(careerTextStyles)(CompareDegrees));
